import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageSquare, Zap, Clock, ShieldCheck, BadgeCheck } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-[#1A1A1A] text-white relative overflow-hidden" data-id="element-136" data-mp="c6ittrduzx63">
      {/* Background accent */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-[#C8102E] opacity-10 blur-[100px] rounded-full transform translate-x-1/2" data-id="element-137" data-mp="84nswnzublsu"></div>
      <div className="absolute bottom-0 left-0 w-1/3 h-1/2 bg-[#C8102E] opacity-5 blur-[120px] rounded-full" data-id="element-138" data-mp="m3dnnwz6t9e1"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center" data-id="element-139" data-mp="h3rcdt2x637v">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-140" data-mp="vtyjxdre21ts">
          {/* Free Estimate Badge - Hero of the section */}
          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-[#C8102E] text-white font-bold mb-6 shadow-[0_0_25px_rgba(200,16,46,0.5)]" data-id="element-141" data-mp="zua6iw3bac7w">
            <BadgeCheck size={20} data-id="element-142" data-mp="2v1fyfh5zs6fj" />
            <span className="uppercase tracking-wider text-sm" data-id="element-143" data-mp="3023nvyekof7n">
              100% Free Estimates · No Obligation
            </span>
          </motion.div>

          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/5 text-gray-300 border border-white/10 font-semibold mb-6 text-sm uppercase tracking-wider" data-id="element-144" data-mp="34vezsdy8rm6f">
            <Zap size={16} className="text-[#C8102E]" data-id="element-145" data-mp="3et2wvajbl5rr" />
            Don't Wait Another Weekend
          </div>

          <h2 className="text-5xl md:text-7xl font-bold mb-8 leading-tight" data-id="element-146" data-mp="3itd40qium287">
            GET YOUR <span className="text-[#C8102E]" data-id="element-147" data-mp="1jov0hsb1kacw">FREE QUOTE</span>{' '}
            <br className="hidden md:block" data-id="element-148" data-mp="1eq1pc6j88vfw" />
            IN UNDER 60 SECONDS.
          </h2>

          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-149" data-mp="1sgx0xql41qn6">
            Tell us what you've got — a single piece, a full garage, or an
            entire property. We'll give you a{' '}
            <strong className="text-white" data-id="element-150" data-mp="22djnqkwzyrru">straight, honest price</strong> on
            the spot. No pressure. No hidden fees. No runaround.
          </p>

          {/* Trust Bar */}
          <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 mb-12 text-sm md:text-base font-semibold" data-id="element-151" data-mp="2behpsxnvkp7s">
            <div className="flex items-center gap-2 text-gray-300" data-id="element-152" data-mp="27epdqaz9w0xo">
              <BadgeCheck size={20} className="text-[#C8102E]" data-id="element-153" data-mp="h2jhcxxe3xcy" />
              <span data-id="element-154" data-mp="czwnysl2m4dn">Always Free</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-155" data-mp="d1hhcevnfh9x">
              <Clock size={20} className="text-[#C8102E]" data-id="element-156" data-mp="2vpyhnwjswg2" />
              <span data-id="element-157" data-mp="2yc6foncpdyt">Same-Day Response</span>
            </div>
            <div className="flex items-center gap-2 text-gray-300" data-id="element-158" data-mp="6w9wsusuy63s">
              <ShieldCheck size={20} className="text-[#C8102E]" data-id="element-159" data-mp="3pc2gss4r4hqu" />
              <span data-id="element-160" data-mp="3p9q2qq246rj2">No Obligation</span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-6 mb-12" data-id="element-161" data-mp="3u92mv31lpkhy">
            <p className="text-sm uppercase tracking-[0.3em] text-gray-400 font-bold" data-id="element-162" data-mp="3fd3hw19sg0h1">
              Call or text for your free estimate
            </p>
            <a href="tel:8312407401" className="text-5xl md:text-7xl font-bold text-[#C8102E] hover:text-red-500 transition-colors drop-shadow-lg" data-id="element-163" data-mp="3ka3frowhhwx2">
              (831) 240-7401
            </a>

            <div className="flex flex-col sm:flex-row gap-4 w-full justify-center mt-2" data-id="element-164" data-mp="14ks86rpk5h1c">
              <a href="tel:8312407401" className="flex items-center justify-center gap-3 bg-[#C8102E] text-white px-10 py-5 rounded font-bold text-xl hover:bg-red-800 transition-all shadow-[0_0_20px_rgba(200,16,46,0.4)] hover:-translate-y-1" data-id="element-165" data-mp="19k50hrz77gbb">
                <Phone size={28} data-id="element-166" data-mp="2vp3mwh57gac9" />
                <span data-id="element-167" data-mp="2voc466wpi73e">Call for Free Estimate</span>
              </a>
              <a href="sms:8312407401" className="flex items-center justify-center gap-3 bg-white text-[#1A1A1A] px-10 py-5 rounded font-bold text-xl hover:bg-gray-100 transition-all shadow-lg hover:-translate-y-1" data-id="element-168" data-mp="2ro1v2ldmb0kb">
                <MessageSquare size={28} data-id="element-169" data-mp="2hvvuwod7pcu1" />
                <span data-id="element-170" data-mp="2cycilu02ra4q">Text Us a Photo</span>
              </a>
            </div>
          </div>

          <div className="bg-white/5 border border-white/10 p-6 rounded-lg max-w-2xl mx-auto" data-id="element-171" data-mp="280az57yql8sq">
            <p className="text-gray-400 text-base md:text-lg" data-id="element-172" data-mp="23xxtsknwjcwh">
              <strong className="text-white" data-id="element-173" data-mp="240a8moyd575b">Pro tip:</strong> Snap a photo of
              your junk and text it over — we can usually quote you in minutes
              without even stepping on-site.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}